export type DogCardHistoryState = {
    key: string;
    __TSR_key: string;
    __TSR_index: number;
    __hashScrollIntoViewOptions: true;
};

export function dogCardHistoryKey() {
    return (Math.random() + 1).toString(36).substring(7);
}

export function nextDogCardHistoryState(
    current: { __TSR_index?: number } | null | undefined,
    key: string,
): DogCardHistoryState {
    const index =
        typeof current?.__TSR_index === "number" ? current.__TSR_index + 1 : 1;
    return {
        key,
        __TSR_key: key,
        __TSR_index: index,
        __hashScrollIntoViewOptions: true,
    };
}

export function shouldCommitDogCardHistory(event: {
    defaultPrevented: boolean;
    button: number;
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
    altKey: boolean;
}) {
    return (
        !event.defaultPrevented &&
        event.button === 0 &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey
    );
}

export function windowHistoryIsRouterOwned(pushState: { toString(): string }) {
    return !pushState.toString().includes("[native code]");
}
